/**
 * Check to see if the user has the role
 */

const userHasRole = (user, role) => {
  return user.role === role
}

export { userHasRole }
